import { useEffect, Fragment, forwardRef, useState } from 'react';
import { Button, Dialog, List, Divider, AppBar, Toolbar, IconButton, Typography, Slide } from '@mui/material';
import EventInfo from './EventInfo';
import CloseIcon from '@mui/icons-material/Close';
import moment from "moment";
import { FaClock } from "react-icons/fa";
import differentOddService from "../../../services/differentOddService";
import { LoadingSpinner } from '../../../components';

const title = ["555 EVENTS", "909 EVENTS"];

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const OddHistory = (props) => {
  const { open, handleClose, eventId, selectedDate } = props;
  const [IsLoading, setIsLoading] = useState(false);
  const [historyData, setHistoryData] = useState([]);

  useEffect(() => {
    //console.log("it run");
    getOddHistory(eventId);
  }, [eventId])

  const getOddHistory = async (eventId) => {
    try {
      setIsLoading(true);
      const payload = {
        selectedDate: selectedDate,
        id: eventId
      };
      const differentOddList = await differentOddService.getOddHistory(payload);
      //console.log("data>>>", differentOddList);
      setHistoryData(differentOddList.data.data);
    } catch (error) {
      console.log({ error });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }} style={{ background: '#292e4c' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Odd History
            </Typography>
            <Button autoFocus color="inherit" onClick={handleClose}>
              Close
            </Button>
          </Toolbar>
        </AppBar>
        <List className='dark:bg-custom_dark_background'>
          {IsLoading ? <LoadingSpinner />
            :
            <Fragment>
              <div className="mx-auto py-1">
                <div className="flex justify-center w-[99%] gap-1">
                  {
                    title.map((v, i) => {
                      return (
                        <div className="flex flex-col w-[45%] max-w-[45%] rounded" key={i}>
                          <div className="w-full text-center bg-background text-white dark:bg-custom_dark_primary2 dark:text-customWhite dark:border-custom_dark_primary py-2 text-lg">
                            {v}
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
              {
                historyData && historyData.map((v, i) => {
                  return (
                    <Fragment key={i}>
                      <div className="mx-auto flex items-center w-[88%] gap-1 text-blue text-sm dark:text-customDarkGreen">
                        <FaClock />
                        <span>
                          {moment(v.createdAt.value).format('DD-MM-YYYY hh:mm a')}
                        </span>
                      </div>
                      <div className="flex justify-center w-[99%] gap-1 my-1">
                        <EventInfo
                          homeTeamName={v.event_555_home}
                          awayTeamName={v.event_555_away}
                          homeOdd={v.home_odd_555}
                          awayOdd={v.away_odd_555}
                          goalOdd={v.goal_odd_555}
                          oddChange={v.is_body_diff || v.is_goal_diff ? true : false}
                        />
                        <EventInfo
                          homeTeamName={v.event_909_home}
                          awayTeamName={v.event_909_away}
                          homeOdd={v.home_odd_909}
                          awayOdd={v.away_odd_909}
                          goalOdd={v.goal_odd_909}
                          oddChange={v.is_body_diff || v.is_goal_diff ? true : false}
                        />
                      </div>
                      <Divider className='my-2' />
                    </Fragment>
                  )
                }
                )}
            </Fragment>
          }
        </List>
      </Dialog>
    </div>
  )
}

export default OddHistory;
